import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {RoleState} from "@/interfaces/state";
import {FunctionPermission, Role} from "@/interfaces/entity";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {RoleParams} from "@/modules/roles/params";
import { union } from "lodash";
import {
    createRole,
    deleteRole, listFunctionPermission,
    listRole,
    singleRole,
    updateRole
} from "@/modules/roles/services";

@Module({ dynamic: true, name: "role", store })
class RoleModule extends VuexModule implements RoleState {
    data: IdMapper<Role> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: RoleParams = new RoleParams();

    functionPermissions: Array<FunctionPermission> = [];

    @Mutation
    private SET_FUNCTION_PERMISSION(payload) {
        this.functionPermissions = payload;
    }

    @Mutation
    private UPDATE_ROLE_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private MAP_ROLE(payload: any) {
        const idMapper: IdMapper<Role> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((role: Role, index: number) => {
            idMapper[role.id!] = {...role, stt: index + 1, isDeleting: false} as any;
            return role.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_ROLE(payload: Role) {
        this.ids = union(this.ids, [ payload.id ]);
        this.data = { ...this.data, [payload.id]: {...payload, isDeleting: false} }
    }

    @Mutation
    private DELETE_ROLE(payload: Role) {
        if (!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.ids = this.ids.filter((id: number) => id !== payload.id);
        delete this.data[payload.id];
    }

    @Mutation
    private START_DELETE_ROLE(id: number) {
        this.data[id].isDeleting = true;
    }

    @Mutation
    private END_DELETE_ROLE(id: number) {
        this.data[id].isDeleting = false;
    }

    @Action({ rawError: true })
    public updateRoleParams(payload: any) {
        this.UPDATE_ROLE_PARAMS(payload);
    }

    @Action({ rawError: true })
    public addRole(payload: Role) {
        this.SET_ROLE(payload);
    }

    @Action({ rawError: true })
    public async createRole(form: any) {
        const { data } = await createRole(form);
        this.SET_ROLE(data.data);
    }

    @Action({ rawError: true })
    public async listRole(params: RoleParams = new RoleParams()) {
        const { data } = await listRole(params);
        this.MAP_ROLE(data);
    }

    @Action({ rawError: true })
    public async singleRole(id: number) {
        const { data } = await singleRole(id);
        return data.data;
    }

    @Action({ rawError: true })
    public async updateRole(dataReq: any) {
        const { data } = await updateRole(dataReq.id, dataReq);
        this.SET_ROLE(data.data);
    }

    @Action({ rawError: true })
    public async deleteRole(id: number) {
        this.START_DELETE_ROLE(id);
        const { data } = await deleteRole(id);
        this.END_DELETE_ROLE(id);
        this.DELETE_ROLE(data.data);
    }

    @Action({ rawError: true })
    public async listFunctionPermission() {
        const { data } = await listFunctionPermission();
        this.SET_FUNCTION_PERMISSION(data.datas);
    }
}

export const RoleStore = getModule(RoleModule);